import React from 'react'
import GraphContainer from '../../../ui_reusable/GraphContainer'
import useDatasetAnalyze from '../cache_query_handler/useDatasetAnalyze'
import usePreloadDatasetAnalyze from '../cache_query_handler/usePreloadDatasetAnalyze'

// Add capitalize function
const capitalize = (str) => {
  if (typeof str !== 'string') return ''

  return str.charAt(0).toUpperCase() + str.slice(1)
}

const DatasetGraph = ({
  datasetId,
  action,
  dataset,
  title,
  helpText,
  overwriteMessage = null,
  isPreloaded = false,
  isSegment = false,
}) => {
  const existingQuery = useDatasetAnalyze(
    isPreloaded ? null : datasetId,
    action,
    dataset?.updated_at,
    isSegment,
  )
  const preloadQuery = usePreloadDatasetAnalyze(
    isPreloaded ? dataset : null,
    action,
  )
  const { data: plotData, isLoading } = isPreloaded
    ? preloadQuery
    : existingQuery

  return (
    <GraphContainer
      title={capitalize(title)}
      data={plotData?.data?.data}
      layout={plotData?.data?.layout}
      config={plotData?.data?.config}
      helpText={helpText}
      loading={isLoading}
      useAIText={false}
      overwriteMessage={overwriteMessage}
    />
  )
}

export default React.memo(DatasetGraph)
